/* eslint-disable @typescript-eslint/no-explicit-any */
const isDOMNode = (o: any) => {
  return typeof Node === 'object'
    ? o instanceof Node
    : o && typeof o === 'object' && typeof o.nodeType === 'number' && typeof o.nodeName === 'string';
};

const $ = (expr: any, container?: any) =>
  typeof expr === 'string' ? (container || document).querySelector(expr) : expr || null;
const $$ = (expr: any, container?: any) => Array.prototype.slice.call((container || document).querySelectorAll(expr));

// adds an element (default: div) defined in eConf to parent element (default: body) - returns element
// i.e.
// const newDiv = ad() = creates a new div, adds to end of page and returns it
// const newDiv = ad({klass: "foo"}) = same as above with class of "foo"
// const newImg = ad({tag: "img", src: "test.png"}, "#top") = image at end of top
function ad(eConf?: any, parent?: any) {
  const c = eConf || {};
  parent = parent ? (typeof parent === 'string' ? document.querySelector(parent) : parent) : document.body;

  let tag = 'div';

  if (c.tag) {
    tag = c.tag;
  }

  const node = document.createElement(tag);

  for (const cc in c) {
    if (c[cc] != null) {
      if (cc === 'klass') {
        // null or undefined
        node.setAttribute('class', c.klass);
      } else if (cc === 'tag') {
        // already swallowed this - intentionally empty
      } else if (cc === 'styles') {
        setStyles(node, c.styles);
      } else if (cc === 'text') {
        node.textContent = c.text;
      } else if (cc === 'html') {
        node.innerHTML = c.html;
      } else {
        node.setAttribute(cc, c[cc]);
      }
    }
  }

  parent.appendChild(node);

  return node;
}

const del = (element: any) => element?.parentNode?.removeChild(element);

const setStyles = (node: any, styles: any) => {
  for (const style in styles) {
    node.style[style] = styles[style];
  }
};

const isAppleMobile = () =>
  (/\b(iPad|iPhone)\b/.test(navigator.userAgent) && /WebKit/.test(navigator.userAgent) && !(window as any).MSStream) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints && navigator.maxTouchPoints === 5);

let _isRtlCached: boolean | undefined;
const isRtl = () => {
  if (_isRtlCached === undefined) {
    _isRtlCached = typeof document !== 'undefined' && document.documentElement.getAttribute('dir') === 'rtl';
  }
  return _isRtlCached;
};

const rgba = (hex: string, alpha: string | number) => {
  hex = hex.replace('#', '');
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map(c => c + c)
      .join('');
  }
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
};

export { $, $$, ad, del, isAppleMobile, isDOMNode, isRtl, rgba, setStyles };
